import {AuthService, OrderService} from 'hasta-la-vista-middleware-api/service';
export default {

    data(){
        return {
            loading: true,
            dsLookup: {action: "", TermUrl: "", PaReq: "", MD: null},
            user: {FullName: null, Email: null, MobilePhone: null},
            card: {cardHolder: null, cardNumber: null, expiryMonth: null, expiryYear: null, cvvNumber: null, debitOrderDay: null, amount: 0},
            years: [],
            months:[{name: "January", value: "1"},{name: "February", value: "2"},{name: "March", value: "3"},{name: "April", value: "4"},{name: "May", value: "5"},{name: "June", value: "6"},{name: "July", value: "7"},,{name: "August", value: "8"},{name: "September", value: "9"},{name: "October", value: "10"},{name: "November", value: "11"},{name: "December", value: "12"}],
            debitDays:[{day:15, name: "15th"},{day:25, name: "25th"},{day:30, name: "30th"}],
            debitOrderTooltip: "",
            userObj: null,
            isGuest: true,
            saveUserData: false,
            subsClub: null,
            saveNewsLetter: false,
            loadingPayment: false,
            showFacebookPixel: false,
        }
    },

    methods: {
        setUser(){
            return AuthService.user().then((user)=> {
                this.userObj = user;
                this.isGuest = user.isGuest();
                if (this.isGuest) window.location.href = '/user/login'
                if (!user.isGuest() && user.MembershipActivated === false && this.first_time) {
                    // this.cookieActive = false;
                    // this.first_time = false;
                } else {
                    // this.showUserActivation = false;
                }

                return this.userObj
            })
        },

        getSubsData() {
            let subsClubRaw = window.localStorage.getItem('subsClub');

            let subsClub = null
            if(subsClubRaw && subsClubRaw != undefined) {
                subsClub = JSON.parse(subsClubRaw)
            }

            this.subsClub = subsClub
            return subsClub
        },

        cancelSubscription() {
            window.localStorage.removeItem('subsClub');
            this.$router.push('/subscription-club')
        },

        continueToNextStep() {
            this.loadingPayment = true;
            let lsItem = {
                'item': this.subsClub.item,
                'userData': this.user,
                'progress': {'currentStep': 3, 'currentStepName': "payment", "currentStepUrl": "/subscribe/3", 'nextStep': 4, "nextStepName": "makePayment", "nextStepUrl": "/subscribe/3"},
            }

            if (this.saveUserData) {
                AuthService.storeLocalUserOrderInfo(this.user)
            }
            else if (this.user.isTemp) {
                AuthService.storeLocalUserOrderInfo(this.user, true)
            }
            else {
                // console.log("not saving User Data", this.user);
            }

            window.localStorage.setItem('subsClub', JSON.stringify(lsItem));
            let itemName = ""
            if(this.subsClub.item.Description == "Unlimited") {
                itemName = "MORvies Subscription";
            } else {
                itemName = "Fan Club Subscription";
            }
            let userDetails = {
                "customerID": this.userObj.MemberId,
                "invoiceID": this.userObj.MemberId,
                "invoiceDescription": "Invoice for " + itemName,
                "contact": {
                    "firstName": this.user.FullName,
                    "lastName": this.userObj.LastName,
                    "company": "",
                    "contactNumber": this.user.MobilePhone, // ?? 10 digit format or country code
                    "email": this.user.Email,
                },
            };

            let pin = this.userObj.MemberId

            this.card.amount = this.subsClub.item.PriceInCents

            lsItem.userDetails = userDetails
            lsItem.pin = pin


            Promise.resolve(OrderService.prepareSubs(this.card, this.subsClub.item, userDetails, pin)).then((result) => {

                if(result.data != undefined && result.data != null) {
                //console.log('result.data',result.data.md)
                let md_decoded = atob(result.data.md)
                //console.log('md_decoded', md_decoded)
                    if(result.success == true) {
                        if(result.data.status == true) {
                            lsItem.currentStepUrl = "/subscribe/3"
                            lsItem.currentStep = 4
                            lsItem.currentStepName = "make-payment"
                            lsItem.nextStep = 5
                            lsItem.nextStepName = "confirm-payment"
                            lsItem.nextStepUrl = ""
                            lsItem.psRef = md_decoded.reference
                            lsItem.debitOrderDay = this.card.debitOrderDay
                            window.localStorage.setItem('subsClub', JSON.stringify(lsItem));
                            document.getElementById('frmLaunchACS').action = result.data.lookup.acsUrl
                            document.getElementById('PaReq').value = result.data.lookup.payload
                            document.getElementById('TermUrl').value = this.dsLookup.TermUrl;
                            document.getElementById('MD').value = JSON.stringify(result.data.md);
                            document.getElementById('frmLaunchACS').submit()
                            this.loadingPayment = false;
                        } else {
                            this.$router.push("/subscribe-failure")
                        }
                    } else {
                        this.$router.push("/subscribe-failure")
                    }
                }

            })

            // this.$router.push('/subscribe/3')
        },

        setDateData() {
            let today = new Date()

            let year = today.getFullYear()
            let yearEnd = year + 10

            for(let y = year; y <= yearEnd; y++) {
                this.years.push({year: y})
            }

            return this.years
        },

        // faceBookPixel() {
        //       !function(f,b,e,v,n,t,s)
        //       {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        //       n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        //       if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        //       n.queue=[];t=b.createElement(e);t.async=!0;
        //       t.src=v;s=b.getElementsByTagName(e)[0];
        //       s.parentNode.insertBefore(t,s)}

        //       (window, document,'script',
        //       'https://connect.facebook.net/en_US/fbevents.js');
        //       fbq('init', '2280338928886721');
        //       fbq('track', 'PageView');
            
        //       this.showFacebookPixel = false

        //       return this.showFacebookPixel;
        // }
    },

    created(){

        this.loading = true;
        Promise.all([this.setUser(), this.getSubsData(), this.setDateData(),  OrderService.getApiHttpDefaultBaseLinkUrl()]).then(([user, subs, dateData, httpData])=> {
            // console.log(this.userObj)

            this.dsLookup.TermUrl = httpData + "/payment/authenticate";

            // console.log(this.dsLookup)
            
            if(this.userObj && !this.userObj.isGuest()) {
                this.user.FullName = this.userObj.FirstName + " " + this.userObj.LastName 
                this.user.Email = this.userObj.Email
                this.user.MobilePhone = this.userObj.MobilePhone
            }

            this.debitOrderTooltip = "This should probably be on payday. The subscription is for a minimum of three months and the second month will be deducted on this day."
            
            this.loading = false
        })
    },

    mounted(){
        window.scrollTo(0, 0)
        window.scroll({top: 0, left: 0})
    },
}


// WEBPACK FOOTER //
// ./src/components/subs-club/payment/payment.js